import {Component} from '@angular/core';
import {AuthenticationService} from '../authentication.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent {
  constructor(public authenticationService: AuthenticationService, private router: Router) {
  }

  email: string;
  password: string;

  signIn() {
    this.authenticationService.SignIn(this.email, this.password);
  }

  goToHome() {
    this.router.navigate(['home']);
  }
}
